// extracted by mini-css-extract-plugin
module.exports = {"text":"styles-module__text___1zy66","reducedFinishScreenImage":"styles-module__reducedFinishScreenImage___2r_Oo","finalScreenImage":"styles-module__finalScreenImage___YRD8B"};